import { SectionColumnViewModel } from './SectionColumnViewModel';
import { Variant } from '../../../../../../../../../models/product/dto/variant';

export class PrintCardColumnViewModel extends SectionColumnViewModel {
  public variant: Variant;
}
